export default __webpack_public_path__ + "static/media/header.16813e7b.jpg";